<template>
  <base-layout>
    <template v-slot:header>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Osnovne informacije
      </h1>
    </template>
    <template v-slot:default>
      <form class="space-y-8 divide-y divide-gray-200">
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Osnovne informacije o promociji
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                Pre početka promocije neophodno je popuniti tražene informacije. Moguća je i naknadna promena ovoh podataka nakon početka promocije.
              </p>
          </div>

          <div>
            <div class="mt-6">
              <fieldset class="mt-6">
                <div>
                  <legend class="text-base font-medium text-gray-900">
                    Tip promocije
                  </legend>
                </div>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input
                        id="sa_poklonom"
                        name="promotion_type"
                        type="radio"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        v-model="promotionType"
                        value="1"
                    >
                    <label for="sa_poklonom" class="ml-3 block text-sm font-medium text-gray-700">
                      Sa poklonom
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input
                        id="sa_popustom"
                        name="promotion_type"
                        type="radio"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        v-model="promotionType"
                        value="0"
                    >
                    <label for="sa_popustom" class="ml-3 block text-sm font-medium text-gray-700">
                      Sa popustom
                    </label>
                  </div>
                </div>
              </fieldset>
              <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-6">
                  <label for="cover_photo" class="text-base font-medium text-gray-900">
                    Fotografija pulta
                  </label>
                  <p class="mt-1 max-w-4xl text-sm text-gray-500">
                    Odaberi sliku klikom na dugme ispod.
                  </p>
                  <div class="mt-1 flex items-center">
                    <input type="file" accept="image/*" @change="uploadImage($event)" id="file-input">
                  </div>
                  <div class="loader" v-if="showLoader"></div>
                </div>

                <div class="sm:col-span-6">
                  <label for="cover_photo" class="text-base font-medium text-gray-900">
                    Fotografija pulta
                  </label>
                  <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                    <div class="space-y-1 text-center">
                      <img :src="imageSrc" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-5">
          <div class="flex justify-end">
            <button
                type="button"
                class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="goBack"
            >
              Otkaži
            </button>
            <button
                class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click.prevent="editPromotion"
            >
              Nastavi
            </button>
          </div>
        </div>
      </form>

    </template>
  </base-layout>
</template>

<script>
import EditPromotionBaseSettings from './EditPromotionBaseSettings';
export default EditPromotionBaseSettings;
</script>